module.exports = __webpack_public_path__ + "img/bg_function04_3_d.3dc99abb.png";